import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { CONTRACT_STATE, CARD_TYPE } from '@shared/types/enums';
import { rulesResetOrderSubState } from '@app/shared/mappers/credit-card.mapper';
import { CustomerContext } from '../../../services/context/customer.context.service';

@Directive({
  selector: '[appShowOrderReset]',
})
export class OrderResetDirective implements OnInit {
  private card: any = {};
  private isContractBlocked!: boolean;

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
    private readonly _customerCtxSvc: CustomerContext
  ) {}

  @Input()
  set appShowOrderResetContractBlocked(isContractBlocked: boolean) {
    this.isContractBlocked = isContractBlocked;
  }

  @Input()
  set appShowOrderReset(card: any) {
    this.card = card;
  }

  ngOnInit() {
    this.updateView();
  }

  private updateView() {
    this.viewContainer.clear();
    //falta implementar el rol en la logica this.rolesService.readRestartShippingOrder
    if (this.card?.type === CARD_TYPE.PHYSICAL && !this.isContractBlocked) {
      if (this.validateResetOrder()) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    }
  }

  private validateResetOrder(): boolean {
    const country = this._customerCtxSvc.context?.country || '';
    switch (country) {
      case 'CO':
        return this.card?.state !== CONTRACT_STATE.ACTIVE && rulesResetOrderSubState['CO'].includes(this.card?.sub_state);
      case 'CL':
        return this.card?.state === CONTRACT_STATE.INACTIVE && rulesResetOrderSubState['CL'].includes(this.card?.sub_state);
      default:
        return this.card?.state === CONTRACT_STATE.INACTIVE && rulesResetOrderSubState['DEFAULT'].includes(this.card?.sub_state);
    }
  }
}
